import { ImageModel } from "../data";

export interface ImagesPayloadModel {
  files: ImageModel[];
}
